module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.FilterItems
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Column Chooser"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "Select",
      "width": "200px"
    },
    on: {
      "change": _vm.columnsSelectionChanged
    },
    model: {
      value: (_vm.columnSelection),
      callback: function($$v) {
        _vm.columnSelection = $$v
      },
      expression: "columnSelection"
    }
  }, _vm._l((_vm.columnOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "40px"
    },
    attrs: {
      "label": "Boro"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Select"
    },
    on: {
      "change": _vm.FilterItems
    },
    model: {
      value: (_vm.boroSelection),
      callback: function($$v) {
        _vm.boroSelection = $$v
      },
      expression: "boroSelection"
    }
  }, _vm._l((_vm.boroOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.allowManage) ? _c('el-form-item', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goToManageZones
    }
  }, [_vm._v("Manage Zones")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.zones,
      "highlight-current-row": ""
    },
    on: {
      "row-click": _vm.zoneActivateClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "gsd_id",
      "label": "Zone ID",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Zone Name",
      "width": "300",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "oat",
      "label": "Outdoor Temp"
    }
  }), _vm._v(" "), (_vm.columns.targetPos) ? _c('el-table-column', {
    attrs: {
      "prop": "targetPosition",
      "label": "Target Pos"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "currentPosition",
      "label": "Current Pos"
    }
  }), _vm._v(" "), (_vm.columns.temperatureReturn) ? _c('el-table-column', {
    attrs: {
      "prop": "temperatureReturnLine",
      "label": "Return Temperature"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.columns.pressureReturn) ? _c('el-table-column', {
    attrs: {
      "prop": "pressureReturn",
      "label": "Return Pressure"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.columns.softwareVersion) ? _c('el-table-column', {
    attrs: {
      "prop": "softwareVersion",
      "label": "Software Version"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mode",
      "label": "Mode"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.mode == 'Manual') ? _c('div', [_vm._v("Valve Set")]) : (scope.row.mode == 'ValveSet') ? _c('div', [_vm._v("Manual")]) : _c('div', [_vm._v(_vm._s(scope.row.mode))])]
      }
    }])
  }), _vm._v(" "), (_vm.columns.compensator) ? _c('el-table-column', {
    attrs: {
      "prop": "compensator",
      "label": "Compensator"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.columns.billingDue) ? _c('el-table-column', {
    attrs: {
      "label": "Next Billing",
      "width": "350"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.billingDue) ? _c('div', [_c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v(_vm._s(scope.row.nextBillingAt))])], 1) : _c('div', [_c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v(_vm._s(scope.row.nextBillingAt))])], 1)]
      }
    }], null, false, 2350755131)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f4706e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ZonesDashboard.vue
// module id = 1389
// module chunks = 1